
const useI18n = () => {
    return (_translationId: number, fallback: string) => {
        return fallback
    }
}

export default useI18n